export default __webpack_public_path__ + "static/media/GalleryIcon.076de340.svg";